<template>
  <div class="page sm" v-wechat-title="$route.meta.title">
    <div class="link-btn" @click="goHome" v-if="res.ismain!='undefined'&&res.ismain==1">首页</div>

    <!--关注-->
    <div class="focus" v-if="res.isfocushint==1&&(res.isfocus==0||res.isfocus==null)">
      <img class="icon-focus" :src="focusRes.isconfig==6?focusRes.focusimg:require('../../assets/icon-focus.png')" alt="">
      <span class="focus-txt hide">{{focusRes.isconfig==6?focusRes.focusinfo:'关注金牌解说&nbsp;&nbsp;收听更多景区讲解'}}</span>
      <span class="focus-btn" @click="focusFun()" v-if="isNaN(parseInt((focusRes.focusinfo).replace(/[^0-9]/ig,'')))">关注</span>
      <a class="focus-btn" :href="'tel:' + parseInt((focusRes.focusinfo).replace(/[^0-9]/ig,''))" v-else>拨号</a>
    </div>

    <!--轮播图-->
    <div class="swiper-con border-box" style="position: relative;">
      <img class="icon-share" src="../../assets/icon-share.png"  @click="showPoster" />
      <Swiper :banners="banners" :type="'view'"></Swiper>
    </div>

    <!--分隔条-->
    <div class="img-line"></div>

    <!--语音景区详情及目录地图切换-->
    <div class="tab-intro box border-box">
      <i class="sm-line"></i>
      <div @click="tabIntroCurr=1" class="flex tab-intro-btn01" :class="tabIntroCurr==1?'curr':''">
        <img class="scenic-icon" src="../../assets/sm-nav01.png" alt="">
        <img class="scenic-icon-curr" src="../../assets/sm-nav01-curr.png" alt="">
        <span>语音讲解</span>
      </div>
      <div @click="tabIntroCurr2" class="flex tab-intro-btn02" :class="tabIntroCurr==2?'curr':''">
        <img class="scenic-icon" src="../../assets/sm-nav02.png" alt="">
        <img class="scenic-icon-curr" src="../../assets/sm-nav02-curr.png" alt="">
        <span>寺庙简介</span>
      </div>
      <div @click="catalogueCurr1" class="flex tab-intro-btn03">
        <img class="scenic-icon" src="../../assets/sm-nav03.png" alt="">
        <img class="scenic-icon-curr" src="../../assets/sm-nav03-curr.png" alt="">
        <span>讲解目录</span>
      </div>
    </div>

    <!--语音列表-->
    <div class="voice-box" :class="tabIntroCurr==2?'none':''">
      <!--研学活动打卡胶囊-->
      <img v-if="res.isStudy==1" class="activity-btn" @click="studyActivity" src="../../assets/activity-btn.png" alt="">

      <!--视频专辑-->
      <div class="video-con border-box" v-if="videoList.length>0">
        <div class="video-vr-tit border-box">短视频
          <p class="fr" v-if="videoTotal>1" @click="goVideoList(videoList[0].id,0)">查看更多</p>
        </div>
        <div class="video-con-box">
          <ul class="video-con-list clearfix">
            <li v-for="(item,index) in videoList" :key="item.id" v-if='index<3' @click="goVideoList(item.id,index)">
              <img class="img" v-lazy="item.headimg" alt="">
              <img class="icon" src="../../assets/view-video-bf.png" alt="">
              <p class="video-con-name border-box">{{item.title}}</p>
            </li>
            <li class="last" @click="goVideoList(videoList[0].id,0)">
              <img class="img" src="../../assets/a_02.jpg" alt="">
              <p>查看全部<br/>+短视频+</p>
            </li>
          </ul>
        </div>
        <div class="split-line h13"></div>
      </div>

      <!--新增VR真人讲解模块-->
      <div class="video-vr border-box video-vr1" v-if="VRlist.length>0&&shop.vr2bag==1">
        <div class="video-vr-tit">VR真人讲解
          <router-link class="fr none" v-if="VRtotal>3" :to="{path:'/video-vrlist',query: {shopid:shopid,spotid:spotid,TimeStamp:TimeStamp,appKey:appKeyA}}">查看更多</router-link>
        </div>
        <div class="list sm border-box">
          <div class="list-box box border-box" v-for="(item,index) in VRlist" :key="index" @click="goVideoVR(item.id,item.label)">
            <div class="block list-img">
              <img class="icon-tx" v-lazy="item.headimg" alt="">
            </div>
            <div class="block flex list-info">
              <span class="gftj" v-if="item.tui">官方推荐</span>
              <div class="list-name guide-name hide">{{item.fname}}
                <span v-if="item.guidetag">{{item.guidetag}}</span>
              </div>
              <div class="list-group hide">
                <span class="fl hide">{{item.name}}</span>
                <span v-if="item.label" class="label-color label-type">{{item.label}}</span>
              </div>
              <div class="mt20 clearfix">
                <div v-if="item.listencount>0" class="label-color">
                  <img class="fl" src="../../assets/adot-3.png" alt="">
                  <span>{{item.listencount|initNumber}}人学习</span>
                </div>
              </div>
              <div class="mt10 clearfix">
                <div class="label-color">
                  <img class="fl" style="margin-left: .03rem;margin-right: .13rem;" src="../../assets/sm-icon02.png" alt="">
                  <span>包含{{item.spotNum}}个讲解点</span>
                </div>
              </div>
              <!--右侧购买收听按钮-->
              <button class="btn buy-btn buy-btn1" @click.stop="goVideoVR(item.id,item.label)">观看</button>
            </div>
          </div>
        </div>
      </div>
      <!--新增VR真人讲解模块（原本的VR样式）-->
      <div class="video-vr border-box" v-else-if="VRlist.length>0&&shop.vr2bag!=1">
        <div class="video-vr-tit">VR真人讲解
          <router-link class="fr none" v-if="VRtotal>3" :to="{path:'/video-vrlist',query: {shopid:shopid,spotid:spotid,TimeStamp:TimeStamp,appKey:appKeyA}}">查看更多</router-link>
        </div>
        <div class="video-vr-con">
          <div class="video-vr-top" @click="goVideoVR(VRlist[0].id,VRlist[0].label)">
            <div class="video-vr-img" id="video-vr-img" v-if="VRlist[0].vrimg&&VRlist[0].vrimg!=''&&VRlist[0].vrimg!=null"></div>
            <img class="video-vr-img" v-lazy="VRlist[0].tvideourl" alt="" v-else>
            <span class="video-vr-mask" v-if="loadPSV"></span>
            <img class="video-vr-btn pause" src="../../assets/view-video-bf.png" alt="" v-if="loadPSV">
            <img class="icon_360" src="../../assets/icon_360.png" alt="">
            <div class="video-tit border-box hide">{{VRlist[0].name}}</div>
            <span class="video-vr-txt num">{{VRlist[0].listencount|initNumber}}次播放</span>
            <span class="video-vr-txt spot">{{VRlist[0].spotNum}}个讲解点</span>
          </div>
          <div class="video-vr-bot border-box" v-if="VRtotal==1">
            <img class="fl video-vr-guide" v-lazy="VRlist[0].headimg" alt="">
            <span class="fl video-vr-name hide">{{VRlist[0].fname}}</span>
            <button class="fr btn buy-btn buy-btn2" @click="goVideoVR(VRlist[0].id,VRlist[0].label)">观看</button>
          </div>

          <div class="video-vr-top" @click="goVideoVR(VRlist[1].id,VRlist[1].label)" style="margin: .24rem 0 .2rem;" v-if="VRtotal>=2&&VRtotal%2==0">
            <img class="video-vr-img" v-lazy="VRlist[1].vrimg" alt="">
            <span class="video-vr-mask"></span>
            <img class="icon_360" src="../../assets/icon_360.png" alt="">
            <div class="video-tit border-box hide">{{VRlist[1].name}}</div>
            <span class="video-vr-txt num">{{VRlist[1].listencount|initNumber}}次播放</span>
            <span class="video-vr-txt spot">{{VRlist[1].spotNum}}个讲解点</span>
          </div>
        </div>
        <div class="video-vr-con video-vr-con1" v-if="VRtotal>2">
          <div class="video-vr-top" :class="((VRtotal%2==0&&index%2==0)||(VRtotal%2==1&&index%2==1))?'fl':'fr'" v-for="(item,index) in VRlist" :key="index" @click="goVideoVR(item.id,item.label)" v-if="((VRtotal%2==0&&index>1)||(VRtotal%2==1&&index>=1))">
            <img class="video-vr-img" v-lazy="item.vrimg" alt="">
            <span class="video-vr-mask" v-if="loadPSV"></span>
            <img class="icon_360" src="../../assets/icon_360.png" alt="">
            <div class="video-tit border-box hide">{{item.name}}</div>
            <span class="video-vr-txt num">{{item.listencount|initNumber}}次播放</span>
            <span class="video-vr-txt spot">{{item.spotNum}}个讲解点</span>
          </div>
        </div>
      </div>

      <!--导游分类-->
      <div class="list-tab box" :class="tablist && tablist.length<5?'list-tab-pf':''">
        <div v-for="(item,index) in tablist" :key="index" @click='tablistClick(item.id)' class="flex" :class="cid == item.id ? 'curr': ''">{{item.name}}</div>
      </div>
      <!--语音列表-->
      <div class="list sm border-box">
        <div class="list-box box border-box" v-for="(item,index) in bagList" :key="index" @click="goVideoPlay(index)">
          <!--左侧头像部分-->
          <div class="block list-img">
            <!--解说员头像-->
            <!--<img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="" @click.stop="goGuideInfo(item.id)">-->
            <img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="">
          </div>
          <!--右侧语音内容部分-->
          <div class="block flex list-info">
            <!--官方推荐标签-->
            <span class="gftj" v-if="item.tui">官方推荐</span>
            <!--语音名称-->
            <div class="list-name guide-name hide">{{item.guidename2?item.guidename2:item.guidename}}
              <span v-if="item.guidetag">{{item.guidetag}}</span>
            </div>
            <div class="list-group hide">
              <span class="fl hide">{{item.name}}</span>
              <span v-if="item.label" class="label-color label-type">{{item.label}}</span>
            </div>
            <!--标签-->
            <div class="mt20 clearfix">
              <div v-if="item.listen>0" class="label-color">
                <img class="fl" src="../../assets/adot-3.png" alt="">
                <span>{{item.listen|initNumber}}人学习</span>
              </div>
            </div>
            <div class="mt10 clearfix">
              <div class="label-color">
                <img class="fl" style="margin-left: .03rem;margin-right: .13rem;" src="../../assets/sm-icon02.png" alt="">
                <span>包含{{item.sees}}个语音解说</span>
              </div>
            </div>
            <!--右侧购买收听按钮-->
            <button class="btn buy-btn buy-btn1" @click.stop="goVideoPlay(index)">收听</button>
          </div>
        </div>

        <p class="load-tip" ref="loadtip">{{loadText}}</p>
      </div>
    </div>

    <!--景区详情内容-->
    <div class="tab-scenic-box" :class="tabIntroCurr==1?'none':''">
      <!--景区信息-->
      <div class="scenic-padding scenic-details-box border-box">
        <div class="scenic-details border-box">
          <div class="scenic-details-title border-box" style="font-size: .32rem;">寺庙信息</div>
          <div class="scenic-details-info mt13" v-if="(shop.info=='')||(shop.info==null)||(!shop.info)" style="padding-bottom: .24rem;border-bottom: 1px solid #e3e3e3;">暂无景区信息</div>
          <div class="scenic-details-info mt13" v-html="shop.info"  style="padding-bottom: .24rem;border-bottom: 1px solid #e3e3e3;" v-else></div>
          <div class="box mt24">
            <div class="flex scenic-details-title left">寺庙地址：</div>
            <div class="flex scenic-details-info right">{{shop.address}}</div>
          </div>
          <div class="box mt6">
            <div class="flex scenic-details-title left">门票价格：</div>
            <div class="flex scenic-details-info right">{{shop.special=='0'?'免费':(shop.special+'元')}}</div>
          </div>
          <div class="box mt6">
            <div class="flex scenic-details-title left">开放时间：</div>
            <div class="flex scenic-details-info right">{{(shop.linestime+shop.lineetime)=='00:0000:00'?'全天':(shop.linestime+'-'+shop.lineetime)}}</div>
          </div>
          <div class="box mt6">
            <div class="flex scenic-details-title left">游玩助手：</div>
            <div class="flex scenic-details-info right">建议游玩时长 {{(shop.routetime=='')||(shop.routetime==null)||(!shop.routetime)?'暂无信息':shop.routetime}}</div>
          </div>
          <div class="box mt6">
            <div class="flex scenic-details-title left">游玩路线：</div>
            <div class="flex scenic-details-info right">{{(routes=='')||(routes==null)||(!routes)?'暂无信息':routes}}</div>
          </div>
          <!--<div class="scenic-details-title left">游玩路线</div>-->
          <!--<div class="scenic-details-info right">{{(routes=='')||(routes==null)||(!routes)?'暂无信息':routes}}</div>-->
        </div>
      </div>
    </div>

    <!--讲解点目录-->
    <div class="alert-box catalogue-box" :class="catalogueCurr==1?'curr':''">
      <div @click="catalogueCurr=0" class="mask"></div>
      <div class="catalogue-item border-box">
        <div class="ml36 font34 cor3" style="font-weight: bold;">讲解目录</div>
        <div class="ml36 catalogue-line"></div>
        <form class="catalogue-input border-box" v-on:submit.prevent="getCatalist()">
          <input class="border-box" :placeholder="shop.name +'（'+ res.spotnum + '个解说点）'" value="" v-model='inputValue'/>
          <img src="../../assets/sm-icon04.png" alt="" @click='getCatalist()'>
        </form>
        <div class="catalogue-item-con border-box">
          <div :id="'CataLi'+item.id" class="catalogue-ul curr" v-for="(item,index) in catalogueRoot" :key="item.id">
            <div class="catalogue-tit"  @click="slideCatalist(item.id)">
              <span style="font-size: .22rem;margin-right: .09rem;">※</span>{{item.name}} <img src="../../assets/sm-icon03.png" alt="">
            </div>
            <div class="catalogue-li-box border-box">
              <router-link class="catalogue-li hide" v-for="(ite,ind) in item.sub" :key="ite.id" @click.native='catalogueCurr=0':to="{path:'/spot-detail-sm',query: {code:code,spotid:ite.id,shopid:shopid,siteid:siteid,sregion:sregion,TimeStamp: TimeStamp, appKey: appKeyA}}">{{ite.name}}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--红包活动弹窗(国庆节日红包)-->
    <AlertRedEnvelope  :redEnvelopes="redEnvelopes" @close="closeEnvelope" v-if="Object.keys(redEnvelopes).length>0"></AlertRedEnvelope>
    <!--红包活动弹窗(攀枝花类型的普通红包)-->
    <AlertRedEnvelNew  :redEnvelNew="redEnvelNew" @close="closeEnvelope" v-if="Object.keys(redEnvelNew).length>0"></AlertRedEnvelNew>

    <!--红包人物-->
    <AlertPersonEnvelope  :shopid="shopid" :personEnvelopes="personEnvelopes" @close="closeEnvelope" v-if="Object.keys(personEnvelopes).length>0"></AlertPersonEnvelope>

    <!--人物推荐+视频推荐(userTui=2)-->
    <AlertRecommendPerson :userTui="userTui" :shopid="shopid" :recommendPerson="recommendPerson" @close="closeEnvelope" v-if="recommendPerson"></AlertRecommendPerson>
    <!--新年人物推荐-->
    <AlertYearPerson  :shopid="shopid" :recommendYear="recommendYear" @close="closeEnvelope" v-if="recommendYear"></AlertYearPerson>


    <!--提醒用户购买弹窗弹窗-->
    <!--<AlertPayTip @close="closePayTip" :comeForm="0" v-if="buyTip==1"></AlertPayTip>-->

    <!--海报弹窗-->
    <AlertPoster  :id="shopid" :type="'shop'" @close="closePoster" v-if="posterShow==1"></AlertPoster>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>

    <!--关注公众号弹窗-->
    <Focus :focusRes="focusRes" v-on:alert-Focus="closeFocus()" v-if="focusEwmShow==1"></Focus>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>

<script>

  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import { mapState, mapMutations } from 'vuex'
  import Swiper from '../../components/Swiper'
  import {getViewDetailSm, getBagTab, getCatalogueSm, uploadScan, getEnvelope, getUserTui, uploadUserBrowse, getNotice,getViewVr,getVideoList,ScanTip} from "@/service/getData";
  import {wxGetPosition,wxShareme} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import AlertRedEnvelope from '../../components/AlertRedEnvelope'
  import AlertPersonEnvelope from '../../components/AlertPersonEnvelope'
  import AlertRecommendPerson from '../../components/AlertRecommendPerson'
  import AlertYearPerson from '../../components/AlertYearPerson'
  import AlertRedEnvelNew from '../../components/AlertRedEnvelNew'
  import AlertPayTip from '../../components/AlertPayTip'
  import AlertPoster from '../../components/AlertPoster'
  import Focus from '../../components/Focus'
  import P400 from '../../components/P400'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        code: this.$route.query.code || '', //城市站点id
        siteid:'',//站点id
        sregion:'',//省站点id:430000
        qrcode: '', //是否是扫码
        qid: '', //扫码id
        shopid: this.$route.query.shopid || '', //景区id
        spotid: '', //景点id
        userInfo: {}, //用户信息
        inputValue: '',//搜索关键词
        page: 1,
        rows: 10,
        loadText: "数据加载中",
        res: "", //全部数据
        cid: "", //导游筛选
        bagList: [],//解说列表
        total: '',//解说总数
        banners: [], //banner图片或者video
        shop: '',//景区信息
        routes: '',//游玩路线
        tablist: [],//导游分类列表
        tabIntroCurr: 1,//语音、景区详情及目录切换
        catalogueCurr: 0,//目录弹窗
        catalogueRoot: [],//目录弹窗内容
        personEnvelopes: [], //红包人物
        redEnvelopes: [], //国庆红包数据
        redEnvelNew: [], //攀枝花类型的普通红包
        recommendPerson: '', //推荐人物专辑数据
        recommendYear: '', //推荐人物专辑数据+音频
        userTui: '', //推荐弹窗类型
        Audio: '', //音频dom
        index1: 0, //当前播放音频数组下标(用来记录currIndex，传值给下订单方法)
        bag:{}, //当前试听的专辑
        extral:{}, //存放下单需要的值
        couponid: '', //优惠券id
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        posterShow: 0, //分享海报弹窗

        VRlist: [], //VR视频列表
        VRtotal: 0, //VR视频专辑总数
        focusEwmShow:0,//二维码弹窗0：隐藏   1：显示
        focusRes:'',//二维码弹窗数据

        videoList: [], //视频列表
        videoTotal: 0, //视频专辑总数

        P400: 0, //系统维护中
        PSV: null, //全景图片
        loadPSV: false, //全景是否加载完

        usernote: this.$route.query.usernote || '', //扫码得到的时间戳
      }
    },
    computed: {

    },
    created(){
      this.$loading.show('数据加载中');
      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }
      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }
      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }
      this.initData(this.page);
      this.getTablist();
      this.getCatalist();
      this.getVr();
      this.getVideoList();

      this.qrcode = this.$route.query.qrcode;
      this.qid = this.$route.query.qid;
      if(this.qid){
        setStore("qid", {"qid":this.qid});
      }
      if(this.qrcode){
        let self = this;
        wxGetPosition(function(res){
          self.sendScan(res.latitude,res.longitude);
        });
      }

      //红包活动
      if(this.shopid!=69 || (this.shopid==69&&this.qid==134)){
        this.getActivity();
      }

      if(this.usernote){
        this.getScanTip();
      }

      window.addEventListener("scroll",this.handleFun)
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun);
      if (this.PSV) {
        this.PSV.destroy()
      }
    },
    methods: {

      //获取语音+景区+推荐信息
      async initData(page){
        let res = await getViewDetailSm({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: page,
          rows: this.rows,
          shopid: this.shopid,
          cid: this.cid
        });

        if (res.errcode === "00000"){
          this.$loading.hide();

          this.res = res.data;
          this.focusRes = res.data;
          this.banners = res.data.bannerinfo;
          this.shop = res.data.shop;
          this.routes = res.data.routes;

          this.total = res.data.total;
          for(var i=0; i<res.data.root.length; i++){
            res.data.root[i].isplay = 0;
            res.data.root[i].toaTime = '';
            res.data.root[i].resTime = '';
          }
          let bagList = res.data.root
          if (page >= Math.ceil(this.total / this.rows) || bagList.length >= this.total) {
            this.loadText = '已经到底了'
          } else {
            this.loadText = '加载更多'
          }
          if (bagList.length > 0) {
            this.bagList = [...this.bagList, ...bagList];
          } else {
            if (page == 1) {
              this.bagList = [];
              this.loadText = '暂无数据'
            } else {
              this.loadText = '已经到底了'
            }
          }

          var share = res.data.share;
          let link = '/view-detail-sm?shopid='+ this.shopid +'&siteid='+ this.siteid + '&sregion='+ this.sregion  +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          if(share == null){
            let title = '金牌解说 | ' + this.shop.name;
            let desc = '历史会说话！金牌解说为您讲解' + this.shop.name + '的历史故事';
            let img = this.banners[0].img;
            wxShareme(title,desc,img,link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }

          this.$route.meta.title = this.shop.name;

        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }

      },

      //获取VR数据
      async getVr(){
        let res = await getViewVr({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          shopid: this.shopid,
          spotid: this.spotid || '',
          page:1,
          rows:50
        });
        if(res.errcode == '00000'){
          if(res.data.root != null && res.data.root.length > 0){
            this.VRlist = res.data.root;
            this.VRtotal = res.data.total;

          }
        }
      },

      //获取视频数据
      async getVideoList(){
    let res = await getVideoList({
      TimeStamp: this.TimeStamp,
      openid: this.userInfo.openid,
      shopid: this.shopid,
      orderby: 'tui',
    });
    if(res.errcode == '00000'){
      if(res.data.data != null && res.data.data.length > 0){
        this.videoList = res.data.data;
        this.videoTotal = res.data.total;
      }
    }
  },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          if(self.tabIntroCurr == "1"){
            loadMore(self,function(page){
              self.initData(page);
            });
          }
        })
      },

      //获取红包活动数据
      async getActivity(){
        let res1 = await getEnvelope({
          TimeStamp: this.TimeStamp,
          openId: this.userInfo.openid,
          type: 0,
          shopId: this.shopid
        });

        if (res1.errcode == '00000' && res1.errmsg == 'SUCCESS' && res1.data.length > 0) {
          if(res1.data[0].model == 1){ //红包活动弹窗（攀枝花类型的普通红包）
            res1.data[0].takeEnvelope = 0;
            this.redEnvelNew = res1.data[0].coupon;
          }else if(res1.data[0].model == 2){
            this.$toast('红包已领取成功')
          }else {   //红包活动弹窗（国庆红包数据）
            res1.data[0].takeEnvelope = 0;
            this.redEnvelopes = res1.data[0];
          }
        } else {
          //配置活动
          let res2 = await getUserTui({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            shopid: this.shopid
          });
          if (res2.errcode == '00000' && res2.data != null) {
            if(res2.data.type == 1){ //推荐音频
              this.recommendYear = res2.data;
            }else if(res2.data.type == 0 || res2.data.type == 2){ //推荐图片 + 推荐视频
              this.userTui = res2.data.type;
              this.recommendPerson = res2.data;
            }
          }

        }

      },

      //提醒用户重新扫码弹窗
      async getScanTip(){
        let res = await ScanTip({
          id: this.shopid,
          usernote: this.usernote,
          openid: this.userInfo.openid
        });
        if (res.errcode === "00000"){
          this.$alert({
            title: '温馨提示',
            content: '如您使用时退出了页面，可在景区内重新扫码进入',
            btnText: '知道了'
          });
        }
      },


      //上传扫码数据
      async sendScan(lat,lng){
        let res = await uploadScan({
          openid: this.userInfo.openid,
          shopid: this.shopid,
          qid: this.qid || "",
          lat: lat || "",
          lng: lng || ""
        });
      },

      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      //请求导游分类
      async getTablist(){
        let res = await getBagTab({
          TimeStamp: this.TimeStamp,
          openid:  this.userInfo.openid,
          shopid: this.shopid
        });
        if (res.errcode === "00000"){
          this.tablist = res.data.root
        }
      },

      //请求讲解点目录
      async getCatalist(){
        let res = await getCatalogueSm({
          TimeStamp: this.TimeStamp,
          type: 0,
          id: this.shopid,
          name: this.inputValue
        });
        if (res.errcode === "00000"){
          this.catalogueRoot = res.data.root
        }
      },

      //目录展开与隐藏
      slideCatalist(index){
        var isCurr = document.getElementById('CataLi'+index);
        if(isCurr.classList.contains('curr')){
          isCurr.classList.remove("curr");
        }else{
          isCurr.classList.add("curr");
        }
      },

      //导游分类列表切换
      tablistClick(cid){
        MtaH5.clickStat("view_detail_tab");
        this.bag = {};
        this.$loading.show('数据加载中');
        this.loadText = '数据加载中'
        this.page = 1;
        this.bagList = [];
        this.cid = cid;
        this.initData(this.page);
      },


      //点击购买，调用下订单公用方法
      buyVideoVr(id){
        let self = this;
        setStore("source", {"source": "video"});
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+id+'&cid='+self.couponid+'&shopid='+self.shopid+'&bagtype=2'+'&appKey='+(self.appKey)}`
        });
      },

      //关闭活动弹窗
      closeEnvelope(msg){
        this.redEnvelopes = msg.redEnvelopes;
        this.personEnvelopes = msg.personEnvelopes;
        this.recommendPerson = msg.recommendPerson;
        this.recommendYear = msg.recommendYear;
        if(msg.redEnvelNew1){
          this.redEnvelNew = [];
          if(msg.type == 0){
            this.$toast('领取成功，购买专辑立减哟');
          }
        }
      },

      //跳转到专辑详情页
      goVideoPlay(ind,listType,rewardShow){
        MtaH5.clickStat('jingqujingdiana-2',{'1tovideo':'true'});//景区景点1进入专辑详情》点击购买》支付
        MtaH5.clickStat('jingqujingdiana-3',{'1tovideo':'true'});//景区景点1进入专辑详情》试听》购买》支付
        MtaH5.clickStat('jingqujingdiana-4',{'1tovideo':'true'});//景区景点1进入专辑详情》试听》弹窗购买》支付

        let list = this.bagList ;
        if(rewardShow){
          this.$router.push({
            path: `/video-play-sm?${'id='+list[ind].id+'&spotid='+list[ind].spotid+'&shopid='+this.shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&rewardShow=1'}`
          });
        }else {
          if((list[ind].buy!=12)&&(!list[ind].isuser)){
            MtaH5.clickStat('list_detail_button')
          }
          this.$router.push({
            path: `/video-play-sm?${'id='+list[ind].id+'&spotid='+list[ind].spotid+'&shopid='+this.shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }
      },

      //跳转到VR视频
      goVideoVR(id,label){
        if(label=='turn'){
          this.$router.push({
            path: `/video-vr?${'id='+id+'&shopid='+this.shopid+'&spotid='+this.spotid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=2&label=turn'}`
          });
        }else {
          this.$router.push({
            path: `/video-vr?${'id='+id+'&shopid='+this.shopid+'&spotid='+this.spotid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=2'}`
          });
        }
      },


      //跳转到导游详情页
      goGuideInfo(id){
        MtaH5.clickStat("view_detail_person");
        MtaH5.clickStat('jingqujingdiana',{'1guide':'true'});//景区景点1点击导游头像》个人主页购买》支付
        this.$router.push({
          path: `/guide-info?${'id='+ id + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      },

      //跳转到首页
      goHome(){
        if(this.code){
          this.$router.push({
            path: `/city-site?${'code='+ this.code + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }else if(this.res.domain){
          window.location = this.res.domain
        }else {
          MtaH5.clickStat("view_to_home");//景区详情页面点击跳转首页
          this.$router.push({
            path: `/?${'siteid='+ this.siteid + '&sregion='+ this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }
      },

      //显示分享海报弹窗
      showPoster(){
        MtaH5.clickStat('poster_share',{'viewdetail':'true'});
        this.posterShow = 1;
      },

      //关闭分享海报弹窗
      closePoster(msg){
        this.posterShow = msg;
      },

      //景区介绍
      tabIntroCurr2(){
        this.tabIntroCurr = 2;
        MtaH5.clickStat('view_detail');
      },

      //讲解点目录
      catalogueCurr1(){
        this.catalogueCurr = !this.catalogueCurr;
        MtaH5.clickStat("catalogue");
      },

      //关注公众号
      focusFun(){
        MtaH5.clickStat("focus");//关注公众号
        this.focusEwmShow = 1;
      },

      //公众号弹窗关闭
      closeFocus(){
        this.focusEwmShow = 0;
      },

      //跳转到地图界面
      toMap(){
        this.$router.push({
          path: `/map?${'siteid='+ this.siteid + '&sregion='+ this.sregion + '&shopid='+ this.shopid + '&spotid='+ this.spotid + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      },

      //研学活动打卡胶囊跳转页面
      studyActivity(){
        window.location.href = this.res.studyUrl + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
      },

      showPhotoVR(imgurl,obj){
//        var imgurl = require('../../assets/qj.jpg');
        var self = this;
        this.PSV = PhotoSphereViewer({
          container: obj,
          panorama: imgurl,
          autoload: true, //自动播放
          time_anim: 2000, //默认2000
          anim_speed: '2rpm', //默认2rpm
          navbar: false,  //不显示下面的导航栏
          overload: function(){
            self.loadPSV = true;
          }
        });
      },

      //跳转到视频专辑页面
      goVideoList(id,ind){
        this.$router.push({
          path: `/video-list?${'id='+id+'&ind='+ ind +'&shopid='+this.shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=4'}`
        });
      },

    },
    watch:  {
      bag(newVal,oldVal){

      },
      VRlist(){
        var self = this;
        this.$nextTick(function(){
          if(self.VRlist[0].vrimg && self.VRlist[0].vrimg != '' && self.VRlist[0].vrimg != null && self.shop.vr2bag!=1){
            self.showPhotoVR(self.VRlist[0].vrimg,'video-vr-img');
          }
        })
      },
    },
    components: {
      Swiper,
      AlertRedEnvelope,
      AlertPersonEnvelope,
      AlertRecommendPerson,
      AlertYearPerson,
      AlertRedEnvelNew,
      AlertPayTip,
      AlertPoster,
      Focus,
      P400
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  @import "../../style/voice.css";
  .page{ padding-bottom:1.42rem;background: url("../../assets/sm-shade.png") repeat;}
  /*轮播图*/
  .sm .swiper-con{width:100%;height: 3.8rem;}
  .sm .swiper-container .swiper-box,.swiper-box .swiper-container{border-radius: 0!important;}
  .sm .icon-share{position:absolute;top:.1rem;right:.12rem;width: .51rem;height: .51rem;padding:.10rem;z-index:2;}

  /*分隔条：图片*/
  .img-line{width:100%;height:.19rem;margin-top: .04rem;background: url("../../assets/sm-line.png") repeat;background-size: auto 100%;}


  /*语音、详情、目录切换*/
  .sm .tab-intro {position: fixed;left:0;bottom:0;z-index: 100;width:100%;height:1.4rem;text-align:center;color:#afa08e;background: url("../../assets/sm-shade.png") repeat;}
  .sm .tab-intro .sm-line{position: absolute;left: 0;top:0;width: 100%;height: .19rem;background: url("../../assets/sm-line.png") repeat;background-size: auto 100%;}
  .sm .tab-intro .flex img {display: block;width:.48rem;height:.48rem;margin:.35rem auto 0;}
  .sm .tab-intro img.scenic-icon-curr{display: none;}
  .sm .tab-intro span {display: block;margin-top:.1rem;font-size:.24rem;color: #afa08e;}
  .sm .tab-intro .flex.curr .scenic-icon-curr {display: block;}
  .sm .tab-intro .flex.curr .scenic-icon {display: none;}
  .sm .tab-intro .flex.curr span {color: #796042;}

  /*导游分类*/
  .sm .list-tab {width: 100%;height:.72rem;line-height:.72rem;margin-top:.15rem;white-space:nowrap;overflow-x: auto;}
  .sm .list-tab .flex {position:relative;/*display: inline-block;width:22.67%!important;*/height:.72rem;line-height:.72rem;text-align:center;font-size:.28rem;color:#666;  }
  .sm .list-tab .flex.curr{color: #796042;font-size: .3rem;}
  .sm .list-tab .flex.curr:after{content:'';position:absolute;bottom:0;left:50%;z-index:1;width: 42%;height:.06rem;background:#796042;border-radius: .15rem;-webkit-transform: translateX(-50%);transform: translateX(-50%);}
  .sm .list-tab.list-tab-pf{display:-webkit-box;display:box;}
  .sm .list-tab.list-tab-pf .flex{display:block;width:initial;-webkit-box-flex:1;box-flex:1;}


  /*新版景区景点详情*/
  .sm .scenic-padding{padding:.32rem .24rem;background:#fff;font-weight:bold;color:#555;}
  .sm .scenic-details-box{position:relative;background: #fff;}
  .sm .scenic-details-box.curr .scenic-details{height:auto;}
  .sm .scenic-details-title{position:relative;font-size:.28rem;color: #796042;font-weight: bold;}
  .sm .scenic-details-info{line-height:.42rem;font-size:.28rem;color:#666;font-weight: normal;}
  .sm .scenic-details-title.left{display:inline-block;width: 1.48rem;line-height: .42rem;text-align: left;}
  .sm .scenic-details-info.right{line-height: .42rem;}

  /*VR真人讲解*/
  .sm .video-vr{padding: 0 .26rem .1rem;margin: .24rem .24rem 0; background: #fff url("../../assets/sm-shade.png") repeat;border-radius: .1rem;box-shadow: 0 0 0.25rem rgba(0,0,0,.15); }
  .sm .video-vr-con{width: 100%;border-radius: .1rem;box-shadow: 0 0 .25rem #f7f7f7;overflow: hidden;}
  .sm .video-vr-tit{width:100%;height: .96rem;font: bold .28rem/1.03rem "Microsoft YaHei";color: #3d3d3d;overflow: hidden;}
  .sm .video-vr-tit .fr{font:normal .24rem/1.03rem "Microsoft YaHei";color: #555;}
  .sm .video-vr-top{ display: block; position:relative;width: 100%;height: 3rem;border-radius: .1rem .1rem 0 0;overflow: hidden;}
  .sm .video-vr-img{position:absolute;top:0;left:0;width: 100%;height: 100%;border-radius: .1rem .1rem 0 0;object-fit: cover;}
  .sm .video-vr-mask{position: absolute;z-index: 1;top:0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.3);}
  .sm .video-vr .icon_360{position: absolute;z-index: 1;top:.12rem;right:.12rem;width: 1.36rem;height: auto;}
  .sm .video-vr .video-tit{position: relative;z-index: 1;width:100%;height:.75rem;padding: 0 1.6rem 0 .2rem;font: .26rem/.75rem "Microsoft YaHei";color: #fff;}
  .sm .video-vr-btn{position: absolute;z-index:1;top:50%;left:50%;width: 1.02rem;height: auto;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .sm .video-vr-txt{position: absolute;z-index: 1;bottom: .14rem;font: bold .2rem "Microsoft YaHei";color: #fff;}
  .sm .video-vr-txt.num{ left:.2rem;}
  .sm .video-vr-txt.spot{ right:.2rem;}
  .sm .video-vr-bot{position:relative;width:100%;height: .98rem;padding: 0 .2rem;}
  .sm .video-vr-guide{width: .58rem;height: .58rem;margin-top:.2rem;border-radius: 50%;object-fit: cover;}
  .sm .video-vr-name{max-width:70%;margin-left: .15rem;font: .26rem/.98rem "Microsoft YaHei";color: #000;}
  .sm .video-vr-bot .buy-btn{top: 50%;transform: translateY(-50%);}
  .sm .video-vr-bot .buy-btn{ width: 1.24rem;height: .56rem;padding:0;line-height: .54rem;background: none;color: #796042;font-size: .28rem;;border: .01rem solid #796042;}

  .sm .video-vr-con1 .video-vr-top{ margin: .24rem 0 .2rem; width: 48.2%; }
  .sm .video-vr-con1 .icon_360{ top: 42%; right: 50%; margin-right: -.68rem; }
  .sm .video-vr1{padding: 0;margin: 0; background: none;border-radius: 0;box-shadow: none; }
  .sm .video-vr1 .video-vr-tit{ width: auto; padding: .3rem .24rem 0;height: .3rem;line-height: .3rem; }
  .sm .video-vr1 .video-vr-tit .fr{ line-height: .3rem; }

  /*轮播图内跳转首页按钮*/
  .link-btn{position: fixed;z-index:2;right:0;top: 2rem;height: .6rem;padding:0 .28rem;font: .28rem/.6rem "Microsoft YaHei";color:#fff;border-radius: .3rem 0 0 .3rem;background: rgba(0,0,0,.7);}

  /*关注*/
  .focus{width:100%;height: .75rem;background: rgba(0,0,0,.8);color: #fff;}
  .icon-focus{float: left;width: auto;height: .52rem;margin:.115rem .22rem 0 .27rem; }
  .focus-txt{float: left;width:63%;font: .24rem/.75rem "Microsoft YaHei";letter-spacing: .02rem; }
  .focus-btn{float: right;width:1.15rem;height: .5rem;margin-top:.125rem;margin-right:.1rem;border: 1px solid #ffac56;color: #fff;font: .24rem/.5rem "Microsoft YaHei";color: #fff;
    text-align: center;border-radius: .3rem;-webkit-animation: focus 1.2s linear infinite;animation: focus 1.2s linear infinite;-webkit-transform: scale(.96);transform: scale(.96);}
  @-webkit-keyframes focus {
    0%{-webkit-transform: scale(.96);}
    20%{-webkit-transform: scale(1);}
    40%{-webkit-transform: scale(.96);}
    60%{-webkit-transform: scale(1);}
    80%{-webkit-transform: scale(.96);}
    100%{-webkit-transform: scale(1);}
  }
  @keyframes focus {
    0%{transform: scale(.96);}
    20%{transform: scale(1);}
    40%{transform: scale(.96);}
    60%{transform: scale(1);}
    80%{transform: scale(.96);}
    100%{transform: scale(1);}
  }
  .activity-btn{display: block;width: 98%;height: auto;margin: .2rem auto 0;}


  /*列表新样式*/
  .sm .list{margin-top: .11rem;}
  .sm .list-box{height:2.72rem;margin-top: .24rem;padding: .26rem;background: rgba(121,96,66,.1);border-radius: .12rem;}
  .sm .list-box .list-info{position:relative;padding-left: .15rem;}
  .sm .list-box .gftj{position:absolute;top:-.26rem;left:0;width: 1.28rem;height: .3rem;font: .22rem/.3rem "Microsoft YaHei";color: #fff;text-align: center;background: url("../../assets/sm-icon05.png") no-repeat center;background-size: 100% 100%;}
  .sm .list-box .btn.buy-btn1{ right: 0;bottom: .1rem;width: 1.24rem;height: .56rem;padding:0;line-height: .54rem;background: none;color: #796042;font-size: .28rem;;border: .01rem solid #796042;}
  .sm .list-box .list-img,.list-box .list-img .icon-tx{border-radius: .08rem;overflow: hidden;}
  .sm .list-box .list-name {margin-top:.2rem;color: #49351e;}
  .sm .list-box .list-name span{line-height: .3rem;margin-top: -.04rem;margin-left:.06rem;font-size: .2rem;background: rgba(121,96,66,.2);color: #796042;}
  .sm .list-box .list-group {margin-top: .15rem;line-height: inherit;}
  .sm .list-box .list-group span.fl {width: 100%;max-width: inherit;margin-top:0;}
  .sm .list-box .label-color{margin-top: 0;margin-right: 0;}
  .sm .label-color img{top:0;width: auto;height: .3rem;margin-right: .07rem;-webkit-transform: translateY(0);transform: translateY(0);}
  .sm .label-color span{font-size: .24rem;color: #666;}

  /*讲解目录*/
  .sm .catalogue-item{padding: .56rem 0 1.5rem 0;background: url("../../assets/sm-shade.png") repeat;}
  .sm .catalogue-input {padding-left: .36rem;}
  .sm .catalogue-input input {font-size: .28rem;color: #999;border-bottom: 1px solid #cecece;background: none;}
  .sm .catalogue-item-con{top:2.24rem;left:0;bottom:1.5rem;border-bottom: none;}
  .sm .catalogue-line{margin-top: .25rem;background: #796042;}
  .sm .catalogue-tit{position: relative;height: .4rem;line-height: .4rem;padding: .22rem 0 .22rem.36rem;font-size: .28rem;color: #666;}
  .sm .catalogue-tit img{width:auto;height: .13rem;margin-left: .06rem;}
  .sm .catalogue-ul.curr .catalogue-tit img{-webkit-transform: rotate(180deg);transform: rotate(180deg);}
  .sm .catalogue-li-box{display:none;width: 100%;padding-left:.66rem;padding-top: .28rem;padding-bottom:.3rem;background: rgba(238,238,238,.65);}
  .sm .catalogue-ul.curr .catalogue-li-box{display: block;}
  .sm .catalogue-li{ display: block; width: 100%;line-height: .4rem;margin-right: .1rem;margin-top:.28rem;font-size: .28rem;color: #666;}
  .sm .catalogue-li:first-child{margin-top: 0;}
  .sm .catalogue-li span{line-height: .4rem;margin-right:.1rem;font-size: .28rem;color: #796042;}

  /*短视频*/
  .sm .video-con{margin: .24rem .24rem 0; background: #fff url("../../assets/sm-shade.png") repeat;border-radius: .1rem;box-shadow: 0 0 0.25rem rgba(0,0,0,.15);  }
  .sm .video-con .video-vr-tit{ padding: 0 .24rem; }
  .sm .video-con-box{ padding: 0 0 .24rem .16rem; overflow-x: auto; }
  .sm .video-con-list{ width: 8.32rem; padding-right: .24rem; }
  .sm .video-con-list li{ position: relative; float: left; margin-left: .08rem; width: 2rem; height: 3rem; overflow: hidden; border-radius: .13rem; }
  .sm .video-con-list li .icon{ position: absolute; left: 50%; top: 50%; width: .56rem; height: .56rem; transform: translate(-50%,-50%); }
  .sm .video-con-name{ position: absolute; left: 0; right: 0; bottom: 0; z-index: 1; padding: 0 .12rem; height: .59rem; font-size: .2rem; line-height: .64rem; text-align: center; color: #fff; background: url(../../assets/a_01.png) repeat-x; }
  .sm .video-con-list .last p{ position: absolute; left: 0; right: 0; top: 50%; font-size: .24rem; line-height: .34rem; text-align: center; color: #fff; transform: translateY(-50%);   }

</style>



// WEBPACK FOOTER //
// src/page/view-detail/view-detail-sm.vue